// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration=production` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Use ngx-env to access environment variables at build time
const env = (process.env as any);

if (!env) {
  throw new Error('🔴 Fatal error: .env file is not available');
}

const requestedAuthProvider = String(env.NG_AUTH_PROVIDER || 'msal');
if (requestedAuthProvider === 'dummy') {
  throw new Error('[environment.prod] NG_AUTH_PROVIDER=dummy refusé : un JWT non signé ne doit pas ouvrir un Member.');
}

export const environment = {
  production: true,
  // API scopes for authentication
  apiScopes: [`api://${env.NG_API_CLIENT_ID}/access_as_user`],
  // Fournisseur d'identité: 'msal' | 'google'. 'dummy' est refusé au chargement.
  // Le type reste celui de `environment.ts` : `fileReplacements` substitue ce fichier sous les mêmes imports.
  authProvider: requestedAuthProvider as 'msal' | 'google' | 'dummy',
  tenantId: env.NG_TENANT_ID,
  clientId: env.NG_CLIENT_ID,
  // Other environment variables can be accessed similarly
  apiUrl: 'https://edgar.pilet-renaud.ch',
  publicHostname: 'edgar.pilet-renaud.ch',
  // Token for trusted API communication
  trustedToken: env.NG_API_TRUSTED_TOKEN,
  // Sentry DSN for error tracking
  sentryDsn: env.NG_SENTRY_DSN,
  // Production specific features
  enableDebug: false,
  // Groupes Azure AD autorisés à choisir la base RAG
  ragGroups: ['IT', 'Gérance Clientèle'],
  // Fenêtre d'historique discussions : today | yesterday | week | month
  discussionRange: 'week' as const,
  logLevel: 'error',
  // Production specific MSAL settings (we use redirect instead of popup)
  // msalConfig: {
  //   navigateToLoginRequestUrl: false,
  //   popupWindowAttributes: {
  //     width: 500,
  //     height: 500
  //   }
  // }
};

console.log('--- DBG env.prod on build', environment);
